import React from 'react';
import { GlobalStyles, useTheme } from '@mui/material';

const GlobalStylesWrapper: React.FC = () => {
  const theme = useTheme();

  return (
    <GlobalStyles
      styles={{
        '.html-content': {
          paddingLeft: 8,
          paddingRight: 8,
        },
        '.html-content p': {
          backgroundColor: '#FFF9C4',
          padding: 8,
          margin: 0,
          marginBottom: 8,
        },
        '.reservation-comment p': {
          margin: 0,
        },
        '.MuiSnackbar-root': {
          right: '24px !important',
          left: '24px !important',
        },
        '.MuiButton-contained': {
          color: 'white',
        },
        '.MuiPaper-root-MuiSnackbarContent-root': {
          width: '100%',
        },
        '.MuiDrawer-paper': {
          borderRight: 'none !important',
        },
        '.MuiAccordionSummary-root .MuiAccordionSummary-content': {
          margin: '12px 8px !important',
        },
        '.MuiAccordionSummary-root .MuiAccordionSummary-content.Mui-expanded': {
          margin: '12px 8px !important',
        },
        '.MuiAccordionSummary-root.Mui-expanded': {
          minHeight: '0 !important',
        },
        '.MuiAccordionSummary-root.Mui-expanded .MuiTypography-root': {
          marginLeft: '0 !important',
        },
        '.tox-tinymce': {
          borderWidth: '1px !important',
          borderRadius: '0px !important',
        },
        '#editor textarea': {
          display: 'none',
        },
        '.sketch-picker ': {
          borderRadius: '0px !important',
          width: 'calc(100% - 20px) !important',
          boxShadow: 'none !important',
        },

        '::-webkit-scrollbar': {
          width: '10px',
        },
        '::-webkit-scrollbar-track': {
          boxShadow: 'inset 0 0 5px grey',
          borderRadius: '10px',
        },
        '::-webkit-scrollbar-thumb': {
          background: theme.palette.secondary.contrastText,
          borderRadius: '10px',
          transition: '0.2s',
        },
        '::-webkit-scrollbar-thumb:hover': {
          background: theme.palette.primary.contrastText,
        },

        '.recharts-pie-labels': {
          display: 'none',
        },

        /* MUI X Pickers Overrides */
        '.MuiPickersDay-root.Mui-selected': {
          color: 'white !important',
        },
        '.MuiMultiSectionDigitalClockSectionItem-root.Mui-selected': {
          color: 'white !important',
          backgroundColor: `${theme.palette.primary.main} !important`,
        },
        '.MuiPickersYear-yearButton.Mui-selected': {
          color: 'white !important',
        },
        '.MuiPickersMonth-monthButton.Mui-selected': {
          color: 'white !important',
        },
        '.MuiDateTimePickerTabs-root': {
          backgroundColor: theme.palette.primary.main,
          '& .MuiTab-root': {
            color: 'rgba(255, 255, 255, 0.7)',
          },
          '& .Mui-selected': {
            color: 'white !important',
          },
        },
        '.MuiPickersLayout-root': {
          '& .MuiButton-root': {
             color: theme.palette.primary.main,
          }
        },
        '.MuiMultiSectionDigitalClockSectionItem-root.Mui-selected, .MuiMenuItem-root.Mui-selected, .MuiListElement-root.Mui-selected': {
          color: 'white !important',
          backgroundColor: `${theme.palette.primary.main} !important`,
        },
        '.MuiMultiSectionDigitalClockSectionItem-root.Mui-selected:hover, .MuiMenuItem-root.Mui-selected:hover': {
          backgroundColor: `${theme.palette.primary.dark} !important`,
        }
      }}
    />
  );
};

export default GlobalStylesWrapper;
